import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { services } from "../data/siteContent";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <header className="navbar">
      <div className="nav-inner">
        <Link className="brand" to="/" onClick={close}>
          <img src="/logoNavbar.svg" alt="Fairview Container Management" />
        </Link>
        <button className="menu-button" type="button" onClick={() => setOpen((value) => !value)} aria-expanded={open}>Menu</button>
        <nav className={open ? "nav-links open" : "nav-links"} aria-label="Main navigation">
          <NavLink to="/" onClick={close}>Home</NavLink>
          <div className="nav-dropdown">
            <NavLink to="/services" onClick={close}>Services</NavLink>
            <div className="dropdown-panel">
              {services.map((service) => (
                <Link key={service.slug} to={`/services#${service.slug}`} onClick={close}>
                  <strong>{service.title}</strong>
                  <span>{service.summary}</span>
                </Link>
              ))}
            </div>
          </div>
          <NavLink to="/industries" onClick={close}>Industries</NavLink>
          <NavLink to="/about" onClick={close}>About</NavLink>
          <NavLink to="/contact" onClick={close}>Contact</NavLink>
          <NavLink to="/employee" onClick={close}>Employee Login</NavLink>
          <Link className="quote-link" to="/quote" onClick={close}>Request Quote</Link>
        </nav>
      </div>
    </header>
  );
}
